import { RouteObject } from "react-router-dom";
import RouteProtector from "./RouteProtector";
import { lazyWithReload } from "../shared/services/lazyWithReload/lazyWithReload";

const ManageComplaintApplication = lazyWithReload(
  () =>
    import(
      "src/complaint/features/ManageComplaintApplication/ManageComplaintApplication"
    ),
);

const ComplaintForm = lazyWithReload(
  () => import("src/complaint/features/form/ComplaintForm"),
);
const History = lazyWithReload(
  () => import("src/complaint/features/history/History"),
);
const PendingComplaintApplications = lazyWithReload(
  () =>
    import(
      "src/complaint/features/pendingComplaintApplications/PendingComplaintApplications"
    ),
);
const ActiveComplaintApplications = lazyWithReload(
  () =>
    import(
      "src/complaint/features/activeComplaintApplications/ActiveComplaintApplications"
    ),
);
const PastComplaintApplications = lazyWithReload(
  () =>
    import(
      "src/complaint/features/pastComplaintApplications/PastComplaintApplications"
    ),
);

const ManageChamberApplication = lazyWithReload(
  () =>
    import(
      "src/complaint/features/ManageChamberApplication/ManageChamberApplication"
    ),
);

const FormAuth = lazyWithReload(
  () => import("src/complaint/features/form/FormAuth"),
);

const OAuthHandleForComplaint = lazyWithReload(
  () =>
    import(
      "src/complaint/features/OAuthHandleForComplaint/OAuthHandleForComplaint"
    ),
);

const AdminComplaintApplications = lazyWithReload(
  () =>
    import(
      "src/complaint/features/AdminComplaintApplications/AdminComplaintApplications"
    ),
);

const SupervisoryTeamComplaintApplications = lazyWithReload(
  () =>
    import(
      "src/complaint/features/SupervisoryTeamComplaintApplications/SupervisoryTeamComplaintApplications"
    ),
);

export const complaintPaths: RouteObject = {
  path: "/complaint",
  children: [
    ...(import.meta.env.VITE_COMPLAINTS_ACTIVATED === "true"
      ? [
          {
            path: "form",
            element: (
              <RouteProtector allowedUsers={["isBusiness", "isNonGemiUser"]}>
                <ComplaintForm />
              </RouteProtector>
            ),
          },
          {
            path: "history",
            element: (
              <RouteProtector allowedUsers={["isBusiness", "isNonGemiUser"]}>
                <History />
              </RouteProtector>
            ),
          },
          {
            path: "manageComplaintApplication/:complaintId",
            element: (
              <RouteProtector allowedUsers={["isBusiness", "isNonGemiUser"]}>
                <ManageComplaintApplication />
              </RouteProtector>
            ),
          },
          {
            path: "pendingComplaintApplications",
            element: (
              <RouteProtector allowedUsers={["isOrgAdmin"]}>
                <PendingComplaintApplications />
              </RouteProtector>
            ),
          },
          {
            path: "activeComplaintApplications",
            element: (
              <RouteProtector allowedUsers={["isChamber", "isOrgAdmin"]}>
                <ActiveComplaintApplications />
              </RouteProtector>
            ),
          },
          {
            path: "pastComplaintApplications",
            element: (
              <RouteProtector allowedUsers={["isChamber", "isOrgAdmin"]}>
                <PastComplaintApplications />
              </RouteProtector>
            ),
          },
          {
            path: "manageChamberComplaintApplication/:complaintId",
            element: (
              <RouteProtector
                allowedUsers={[
                  "isChamber",
                  "isOrgAdmin",
                  "isSystemAdmin",
                  "isSampleInitiator",
                  "isGGEAdmin",
                  "isSupervisorAssignee",
                ]}
              >
                <ManageChamberApplication />
              </RouteProtector>
            ),
          },
          {
            path: "formAuth",
            element: (
              <RouteProtector allowedUsers={["isNonGemiUser"]}>
                <FormAuth />
              </RouteProtector>
            ),
          },
          {
            path: "oAuthHandleForComplaint",
            element: (
              <RouteProtector allowedUsers={["isNonGemiUser"]}>
                <OAuthHandleForComplaint />
              </RouteProtector>
            ),
          },
          {
            path: "adminComplaintApplications",
            element: (
              <RouteProtector
                allowedUsers={[
                  "isSystemAdmin",
                  "isSampleInitiator",
                  "isGGEAdmin",
                ]}
              >
                <AdminComplaintApplications />
              </RouteProtector>
            ),
          },
          {
            path: "supervisoryTeamComplaintApplications",
            element: (
              <RouteProtector allowedUsers={["isSupervisorAssignee"]}>
                <SupervisoryTeamComplaintApplications />
              </RouteProtector>
            ),
          },
        ]
      : []),
  ],
};
